import { isNonProd } from '~/constants/environment';
import { EventDetail } from '~/contracts/vdp';

const source = 'vdp';

const logToConsole = ({ detail, type }: CustomEvent<EventDetail>) => {
  if (isNonProd) {
    console.debug('Event arrived', { type, detail }); // eslint-disable-line no-console
  }
};

export const generateCustomEventDetail = <T = any>(data?: T): EventDetail => ({
  data,
  source
});

// Ignore events fired by VDP
export const filterLocalEvents =
  <T>(fn: (ev: CustomEvent<EventDetail<T>>) => void) =>
  (ev: CustomEvent<EventDetail<T>>) => {
    logToConsole(ev);
    if (ev.detail.source !== source) fn(ev);
  };

export const addEventListeners = <T extends Event>(
  elements: Array<Element | null>,
  events: [string, (_: T) => void][]
) => {
  events.forEach(([type, listener]) => {
    elements.forEach(el => {
      el?.addEventListener<any>(type, listener);
    });
  });
};

export const removeEventListeners = <T extends Event>(
  elements: Array<Element | null>,
  events: [string, (_: T) => void][]
) => {
  events.forEach(([type, listener]) => {
    elements.forEach(el => {
      el?.removeEventListener<any>(type, listener);
    });
  });
};
